/**
 * Hook for managing Admin Hub favorites
 * Re-exports functionality from AdminHubContext for convenience
 */
import { useAdminHub, type FavoriteItem } from '../components/admin-hub/context/AdminHubContext';

interface UseAdminHubFavoritesReturn {
  favorites: FavoriteItem[];
  addFavorite: (path: string, label: string, section: string) => void;
  removeFavorite: (path: string) => void;
  isFavorite: (path: string) => boolean;
  toggleFavorite: (path: string, label: string, section: string) => void;
}

/**
 * Hook for managing Admin Hub favorites
 * Provides convenient access to favorites state and actions
 */
export const useAdminHubFavorites = (): UseAdminHubFavoritesReturn => {
  const { favorites, addFavorite, removeFavorite, isFavorite } = useAdminHub();

  const toggleFavorite = (path: string, label: string, section: string) => {
    if (isFavorite(path)) {
      removeFavorite(path);
    } else {
      addFavorite(path, label, section);
    }
  };

  return {
    favorites,
    addFavorite,
    removeFavorite,
    isFavorite,
    toggleFavorite,
  };
};

export default useAdminHubFavorites;
